import { render, staticRenderFns } from "./AsignacionesMenu.vue?vue&type=template&id=ae7dd1ce&scoped=true"
import script from "./AsignacionesMenu.vue?vue&type=script&lang=js"
export * from "./AsignacionesMenu.vue?vue&type=script&lang=js"
import style0 from "./AsignacionesMenu.vue?vue&type=style&index=0&id=ae7dd1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7dd1ce",
  null
  
)

export default component.exports